export enum ContinueButtonLabels {
  CONTINUE = 'Continue',
  REVIEW_AND_SIGN = 'Review and sign',
}
